var ACUITY_EMBED_SRC = "https://embed.acuityscheduling.com/js/embed.js";
var ACUITY_SCHEDULE_BASE = "https://app.acuityscheduling.com/schedule.php";
var ACUITY_DEFAULT_OWNER = "17835962";
var ACUITY_DEFAULT_APPOINTMENT_TYPE = "81923893";

var loadAcuityEmbed = () => {
  if (document.querySelector('script[src*="embed.acuityscheduling.com"]')) return;
  const $script = document.createElement("script");
  $script.src = ACUITY_EMBED_SRC;
  $script.async = true;
  document.body.appendChild($script);
};

var buildScheduleUrl = (ownerId, appointmentType, calendarId) => {
  let url = `${ACUITY_SCHEDULE_BASE}?owner=${ownerId}&appointmentType=${appointmentType}`;
  if (calendarId) url += `&calendarID=${calendarId}`;
  return url;
};

var AcuityCalendario = class extends HTMLElement {
  connectedCallback() {
    this.$citySelect = this.querySelector('[name="city"]');
    this.$showroomSelect = this.querySelector('[name="showroom"]');
    this.$iframe = this.querySelector(".calendario__iframe");
    this.$dataScript = this.querySelector("[data-calendario-showrooms]");
    this.$rulesScript = this.querySelector("[data-calendario-rules]");

    if (!this.$citySelect || !this.$showroomSelect || !this.$iframe || !this.$dataScript) return;

    this.showrooms = this.parseJson(this.$dataScript, []);
    this.acuityOwnerId = this.dataset.ownerId || ACUITY_DEFAULT_OWNER;
    this.acuityAppointmentType = this.resolveAppointmentType();

    this.onCityChange = this.onCityChange.bind(this);
    this.onShowroomChange = this.onShowroomChange.bind(this);
    this.$citySelect.addEventListener("change", this.onCityChange);
    this.$showroomSelect.addEventListener("change", this.onShowroomChange);

    this.applyUrlParams();
  }

  disconnectedCallback() {
    this.$citySelect?.removeEventListener("change", this.onCityChange);
    this.$showroomSelect?.removeEventListener("change", this.onShowroomChange);
  }

  parseJson($script, fallback) {
    if (!$script) return fallback;
    try {
      return JSON.parse($script.textContent);
    } catch (error) {
      console.error("acuity-calendario: JSON inválido", error);
      return fallback;
    }
  }

  // Tipo de calendario (appointmentType):
  // 1. Parte del valor que ya resolvió Liquid por la ruta (o el default de la sección).
  // 2. Vuelve a evaluar las reglas contra la URL completa, incluyendo query string (UTMs).
  //    Se recorren todas en orden y gana la última que coincida, igual que el tema anterior.
  resolveAppointmentType() {
    let appointmentType = this.dataset.appointmentType || ACUITY_DEFAULT_APPOINTMENT_TYPE;
    const rules = this.parseJson(this.$rulesScript, []);
    const href = window.location.href.toLowerCase();

    rules.forEach((rule) => {
      if (rule.keyword && rule.appointment_type && href.includes(rule.keyword)) {
        appointmentType = rule.appointment_type;
      }
    });

    return appointmentType;
  }

  applyUrlParams() {
    if (this.$citySelect.options.length === 0) return;

    const params = new URLSearchParams(window.location.search);
    const requestedCity = params.get("ciudad");
    const requestedAcuityId = params.get("id");
    let matchedShowroom = null;
    let shouldScroll = false;

    if (requestedAcuityId) {
      matchedShowroom = this.showrooms.find(
        (showroom) => String(showroom.acuity_id) === String(requestedAcuityId)
      );
    }

    if (matchedShowroom) {
      this.selectCity(matchedShowroom.city);
      this.onCityChange();
      this.selectShowroom(matchedShowroom.acuity_id);
      this.onShowroomChange();
      if (requestedCity && requestedAcuityId) shouldScroll = true;
    } else if (requestedCity && this.hasCityOption(requestedCity)) {
      this.selectCity(requestedCity);
      this.onCityChange();
    } else {
      this.$citySelect.selectedIndex = 0;
      this.onCityChange();
    }

    if (shouldScroll) this.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  hasCityOption(city) {
    return Array.from(this.$citySelect.options).some(($option) => $option.value === city);
  }

  selectCity(city) {
    if (this.hasCityOption(city)) this.$citySelect.value = city;
  }

  selectShowroom(acuityId) {
    const $option = Array.from(this.$showroomSelect.options).find(
      ($item) => $item.value === String(acuityId)
    );
    if ($option) this.$showroomSelect.value = $option.value;
  }

  onCityChange() {
    const city = this.$citySelect.value;
    const filteredShowrooms = this.showrooms.filter((showroom) => showroom.city === city);

    this.$showroomSelect.innerHTML = "";
    filteredShowrooms.forEach((showroom) => {
      const $option = document.createElement("option");
      $option.value = showroom.acuity_id;
      $option.textContent = showroom.showroom_name;
      this.$showroomSelect.appendChild($option);
    });

    if (filteredShowrooms.length > 0) {
      this.onShowroomChange();
    } else {
      this.hideIframe();
    }
  }

  onShowroomChange() {
    const acuityId = this.$showroomSelect.value;
    if (!acuityId) {
      this.hideIframe();
      return;
    }

    loadAcuityEmbed();
    this.$iframe.src = buildScheduleUrl(this.acuityOwnerId, this.acuityAppointmentType, acuityId);
    this.$iframe.classList.remove("calendario__iframe--hidden");
  }

  hideIframe() {
    this.$iframe.src = "";
    this.$iframe.classList.add("calendario__iframe--hidden");
  }
};

if (!window.customElements.get("acuity-calendario")) {
  window.customElements.define("acuity-calendario", AcuityCalendario);
}